// extracted by mini-css-extract-plugin
export var artArchiveStyle = "FeaturedMediaVideo-module--art-archive-style--hQapf";
export var defaultStyle = "FeaturedMediaVideo-module--default-style--pL1Z5";
export var featuredMediaVideo = "FeaturedMediaVideo-module--featured-media-video--fOOMl";
export var homeStyle = "FeaturedMediaVideo-module--home-style--GJT7W";
export var video = "FeaturedMediaVideo-module--video--IkzDM";